export default {
  dataSourcesGroups: (state, getters, rootState) => (mapId) => {
    if (!mapId || !state.dataSourcesGroups[mapId]) {
      return [];
    }

    return state.dataSourcesGroups[mapId];

    // let array = [];
    // for (let key of Object.keys(state.dataSourcesGroups[mapId])) {
    //   array.push({
    //     title: key,
    //     dataSources: state.dataSourcesGroups[mapId][key]
    //   })
    // }
    // return array;
  }
};


// WEBPACK FOOTER //
// ./src/store/maps/getters.js